import { useCallback, useEffect, useState } from 'react';

// Collaborative placement reaches the rendered graph after the drop command.
// Wait for that graph so inbox visibility cleanup cannot clear the selection.
export default function useDroppedIdeaSelection({
  mapId, visibleNodeIds, relationships, setSelectedId, setCaptureTargetId,
  scheduleSelectionGlide, containerRef,
}) {
  const [pending, setPending] = useState(null);
  const selectDroppedIdea = useCallback((nodeId, parentId) => {
    setPending({ nodeId, parentId, mapId });
  }, [mapId]);

  useEffect(() => {
    if (!pending) return;
    if (pending.mapId !== mapId) {
      setPending(null);
      return;
    }
    if (!visibleNodeIds.has(pending.nodeId) || !relationships.some(edge => (
      edge.childId === pending.nodeId && edge.parentId === pending.parentId
    ))) return;
    setPending(null);
    setSelectedId(pending.nodeId);
    setCaptureTargetId(pending.nodeId);
    containerRef.current?.focus({ preventScroll: true });
    scheduleSelectionGlide(pending.nodeId);
  }, [pending, mapId, visibleNodeIds, relationships, setSelectedId,
    setCaptureTargetId, scheduleSelectionGlide, containerRef]);

  return selectDroppedIdea;
}
